// 初期画面ロード時
document.addEventListener('DOMContentLoaded', () => {
  const imageModalViewer = new ImageModalViewer()
  imageModalViewer.initialize()
})

export default class ImageModalViewer {
  constructor() {
    this.currentIndex = 0
    this.keydownHandlerBound = false
  }

  setCurrentIndex(index) {
    this.currentIndex = index

    if(this.currentIndex < 0) {
      this.currentIndex = this.markdownImages.length - 1
    }
    else if(this.currentIndex > this.markdownImages.length - 1) {
      this.currentIndex = 0
    }

    this.openImageModal()
  }

  // currentIndexの画像を表示
  openImageModal() {
    this.modalImg.src = this.markdownImages[this.currentIndex].src
    this.modal.style.display = 'block'
    this.modalCheckbox.checked = true
    this.modalCounter.textContent = `${this.currentIndex + 1} / ${this.markdownImages.length}`

    // キーボードイベントがすでに登録されているか確認
    if(!this.keydownHandlerBound && this.markdownImages.length > 1) {
      document.addEventListener('keydown', this.keydownHandler)
      this.keydownHandlerBound = true
    }
  }

  closeImageModal() {
    this.modal.style.display = 'none'

    if(this.keydownHandlerBound) {
      document.removeEventListener('keydown', this.keydownHandler)
      this.keydownHandlerBound = false
    }
  }

  // インデックを更新するヘルパー関数
  changeImage(delta) {
    this.setCurrentIndex(this.currentIndex + delta)
  }

  keydownHandler = (e) => {
    if(this.modal.style.display === 'none') return

    if(e.key === 'Enter') {
      e.preventDefault()
    }

    if(e.key === 'ArrowLeft') {
      this.changeImage(-1)
    }
    else if (e.key === 'ArrowRight') {
      this.changeImage(+1)
    }
  }

  initialize() {
    this.modalCheckbox = document.querySelector('#image-modal-checkbox')
    this.markdownImages = Array.from(document.querySelectorAll('.js-contents-image img'))
    this.modal = document.querySelector('#js-image-modal')
    this.modalImg = this.modal.querySelector('.modalImage_image')
    this.modalCounter = this.modal.querySelector('.modalImage_counter')
    const prevBtn = this.modal.querySelector('.js-modalImage-prevBtn')
    const nextBtn = this.modal.querySelector('.js-modalImage-nextBtn')
    const closeBtn = this.modal.querySelector('.modal-header__close')
    const modalOverlay = this.modal.querySelector('.modal__overlay')

    if(!this.modal || this.markdownImages.length === 0) return
    this.modalCheckbox.checked = false
    document.removeEventListener('keydown', this.keydownHandler)

    // 画像が2枚以上のみ左右切り替えボタンを表示する
    if(this.markdownImages.length > 1) {
      prevBtn.classList.remove('is-hidden')
      nextBtn.classList.remove('is-hidden')
    }
    // 1枚は非表示
    else {
      prevBtn.classList.add('is-hidden')
      nextBtn.classList.add('is-hidden')
    }

    this.markdownImages.forEach((img, index) => {
      const parent = img.closest('a')

      if(!parent) return

      parent.removeAttribute('target')
      parent.onclick = (e) => {
        e.preventDefault()
        this.setCurrentIndex(index)
      }
    })

    closeBtn.onclick = () => {
      this.closeImageModal()
    }

    modalOverlay.onclick = () => {
      this.closeImageModal()
    }

    prevBtn.onclick = () => {
      this.changeImage(-1)
    }

    nextBtn.onclick = () => {
      this.changeImage(+1)
    }
  }
}